// extracted by mini-css-extract-plugin
export default {"CourseWaitlist":"CourseWaitlistTab_CourseWaitlist__YNVF6","ActionRenderer":"CourseWaitlistTab_ActionRenderer__JUmTu"};